import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import TablePagination from "@mui/material/TablePagination";
import Divider from "@mui/material/Divider";

function createData(rank, teamName, round1, round2, total) {
  return { rank, teamName, round1, round2, total };
}

// const rows = [
//   {rank:4,teamName:'Kaifur Rahman',round1:90,round2:90,total:180},
//   {rank:null,teamName:'Rahinos',round1:40,round2:30,total:50},
//   {rank:null,teamName:'Rahinos',round1:15,round2:70,total:60},
//   {rank:4,teamName:'Rahinos',round1:25,round2:60,total:90},
//   {rank:5,teamName:'Rahinos',round1:90,round2:50,total:110},
//   {rank:null,teamName:null,round1:null,round2:null,total:null},
//   {rank:7,teamName:'Rahinos',round1:40,round2:30,total:120},
//   {rank:8,teamName:'Rahinos',round1:40,round2:30,total:120},
//   {rank:9,teamName:'Rahinos',round1:40,round2:30,total:120},
//   {rank:10,teamName:'Rahinos',round1:40,round2:30,total:120},
//   {rank:11,teamName:'Rahinos',round1:40,round2:30,total:120},
//   {rank:12,teamName:'Rahinos',round1:40,round2:30,total:120}
// ];

export default function BasicTable(props) {
  {
    /*rows per page use state settings*/
  }
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [rank, setRank] = React.useState(1);
  const [style, setStyle] = React.useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <Box
      sx={{
        marginTop: "3rem",
        marginBottom: { lg: "4rem", md: "7rem", sm: "9rem", xs: "10rem" },
      }}
    >
      {/*main container*/}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            {/*column headings*/}
            <TableRow>
              <TableCell
                align="center"
                sx={{
                  width: "4rem",
                  backgroundColor: "#121212",
                  color: "#ffffff",
                }}
              >
                Rank
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  width: "8rem",
                  backgroundColor: "#121212",
                  color: "#ffffff",
                }}
              >
                Team Name
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  width: "4rem",
                  backgroundColor: "#121212",
                  color: "#ffffff",
                }}
              >
                Round-1
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  width: "4rem",
                  backgroundColor: "#121212",
                  color: "#ffffff",
                }}
              >
                Round-2
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  width: "4rem",
                  backgroundColor: "#121212",
                  color: "#ffffff",
                }}
              >
                Total
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/*mapping data here first slice acc to rows per page then map that*/}
            {props.data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <TableRow
                  key={row.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  {/*rank*/}
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    sx={{
                      fontWeight: "bold",
                      fontSize: {
                        lg: "1.3rem",
                        md: "1.1rem",
                        sm: "1rem",
                        xs: "0.9rem",
                      },
                    }}
                  >
                    {props.state ? row.rank : "#"}
                  </TableCell>
                  {/*team name*/}
                  <TableCell
                    align="center"
                    sx={{ fontWeight: "bold", letterSpacing: "0.1rem" }}
                  >
                    {row.teamName === null ? "-" : row.teamName}
                  </TableCell>
                  {/*round 1 marks*/}
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>
                    {row.round1 === null ? "-" : row.round1}
                  </TableCell>
                  {/*round 2 marks*/}
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>
                    {row.round2 === null ? "-" : row.round2}
                  </TableCell>
                  {/*total marks*/}
                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      fontSize: {
                        lg: "1.3rem",
                        md: "1.1rem",
                        sm: "1rem",
                        xs: "0.9rem",
                      },
                    }}
                  >
                    {row.total === null ? "-" : row.total}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <Divider></Divider>
        {/*table pagination*/}
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 100]}
        component="div"
        count={props.data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{
          color: "#000000",
          backgroundColor: "#ffffff",
          borderRadius: "0rem",
          marginTop: "-0.1rem",
        }}
      />
    </Box>
  );
}
